/**
 * Publishing status constants for event templates.
 * These values match the backend API response for the publishingStatus field.
 */
export const PublishingStatus = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
} as const;

export type PublishingStatusType = (typeof PublishingStatus)[keyof typeof PublishingStatus];

/**
 * Polling interval for checking publishing status (in milliseconds).
 * Set to 20 seconds to balance responsiveness with API load.
 */
export const PUBLISHING_STATUS_POLL_INTERVAL_MS = 20000;

